var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevelMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5896 10.3636H9.22597C7.86233 10.3636 6.74112 11.4848 6.74112 12.8485V15H15.0745V12.8485C15.0745 11.4848 13.9532 10.3636 12.5896 10.3636Z",
    fill: "#FF8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22597 10.1212C6.86233 9.87879 6.43809 9.72727 5.98355 9.72727H3.01385C1.80173 9.72727 0.832031 10.697 0.832031 11.9091V13.8182H5.83203V12.8485C5.83203 11.7273 6.37749 10.7273 7.22597 10.1212Z",
    fill: "#FF8A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6502 9.72727H15.6805C15.2563 9.72727 14.8623 9.84848 14.529 10.0606C15.4078 10.6667 15.9835 11.697 15.9835 12.8485V13.8182H20.832V11.9091C20.832 10.697 19.8623 9.72727 18.6502 9.72727Z",
    fill: "#C5C5C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 9.45455C12.3989 9.45455 13.6199 8.2335 13.6199 6.72727C13.6199 5.22104 12.3989 4 10.8926 4C9.38641 4 8.16537 5.22104 8.16537 6.72727C8.16537 8.2335 9.38641 9.45455 10.8926 9.45455Z",
    fill: "#FF8A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1654 8.81818C18.4875 8.81818 19.5593 7.74638 19.5593 6.42424C19.5593 5.10211 18.4875 4.0303 17.1654 4.0303C15.8432 4.0303 14.7714 5.10211 14.7714 6.42424C14.7714 7.74638 15.8432 8.81818 17.1654 8.81818Z",
    fill: "#C5C5C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4987 8.81818C5.82083 8.81818 6.89264 7.74638 6.89264 6.42424C6.89264 5.10211 5.82083 4.0303 4.4987 4.0303C3.17656 4.0303 2.10476 5.10211 2.10476 6.42424C2.10476 7.74638 3.17656 8.81818 4.4987 8.81818Z",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelMedium);
export default __webpack_public_path__ + "static/media/levelMedium.3165d5ee3c3f553f022793af20930f43.svg";
export { ForwardRef as ReactComponent };